import Radio from "@mui/material/Radio";
import { styled } from "@mui/material/styles";

const SoftRadio = styled(Radio)(() => ({
  padding: 8,
  "& .MuiSvgIcon-root": {
    display: "none",
  },
  "&:before": {
    content: '""',
    display: "block",
    width: 28,
    height: 28,
    borderRadius: "100%",
    backgroundColor: "#ffffff",
    border: "6px solid #DDE1E6",
    boxSizing: "border-box",
  },
  "&.Mui-checked:after": {
    content: '""',
    position: "absolute",
    top: 12,
    left: 12,
    width: 16,
    height: 16,
    borderRadius: "100%",
    backgroundColor: "#082E5B",
  },
  position: "relative",
}));

export default SoftRadio;
